import { useFeatureAggregatorRedirectButtonsQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IAggregatorRedirectButton {
  isActive: boolean;
  name: string;
  url: string;
  buttonText: string;
}

export interface IAggregatorRedirectButtons {
  activeButtons: IAggregatorRedirectButton[];
  isLoading: boolean;
}

export const useFeatureAggregatorRedirectButton = (): IAggregatorRedirectButtons => {
  const { featureAggregatorRedirectButtonsId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureAggregatorRedirectButtonsQuery({
    variables: { featureAggregatorRedirectButtonsID: featureAggregatorRedirectButtonsId },
    skip: !featureAggregatorRedirectButtonsId,
  });
  const buttonsData = data?.FeatureAggregatorRedirectButtons?.aggregatorRedirectButtons || [];
  const activeButtons = buttonsData.reduce((accumulator: IAggregatorRedirectButton[], button) => {
    if (button && button.isActive) {
      accumulator.push({
        isActive: button.isActive,
        name: button.name || '',
        url: button.url || '',
        buttonText: button.text?.locale || '',
      });
    }
    return accumulator;
  }, []);
  const isLoading = featureIdsLoading || loading;
  return { activeButtons, isLoading };
};
